import ApiGet from "../../../../api-module/api-configuration/get-api/getApi";
import { API_ENDPOINTS } from "../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider";

export type JobIndexItem = {
    jobId: string;
    jobCode: string;
    jobTitle: string;
    slug: string;
    departmentName: string;
    jobLevelName: string;
    jobType: string;
    status: string;
    publishedAt: string | null;
    closedAt: string | null;
    createdAt: string;
};

export type JobIndexPagination = {
    page: number;
    size: number;
    totalRecords: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
};

export type ApiListResponse<T> = {
    success: boolean;
    requestId: string;
    data: {
        items: T[];
        pagination: JobIndexPagination;
    };
};

export type JobIndexFilters = {
    search?: string;
    department?: string;
    level?: string;
    type?: string;
    status?: string;
};

export const getJobIndexApi = (page = 1, size = 100, filters?: JobIndexFilters) =>
    ApiGet<ApiListResponse<JobIndexItem>>(API_ENDPOINTS.GET_JOB_INDEX ?? "/api/job/index", {
        params: {
            page,
            size,
            ...(filters ?? {}), //NOSONAR
        },
    });

export type DepartmentItem = {
    id: number;
    departmentUuid: string;
    name: string;
    code: string;
    slug: string;
    description: string | null;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
};

export type ApiListNoPaginationResponse<T> = {
    success: boolean;
    requestId: string;
    data: {
        items: T[];
    };
};

export const getDepartmentListApi = () =>
    ApiGet<ApiListNoPaginationResponse<DepartmentItem>>(
        API_ENDPOINTS.GET_DEPARTMENT_LIST
    );

export const getAllJobsForFilters = async () => {
    const first = await getJobIndexApi(1, 50); 
    const pag = first.data.data.pagination;
    const all = [...(first.data.data.items ?? [])];

    if (!pag?.totalPages || pag.totalPages <= 1) return all;

    for (let p = 2; p <= pag.totalPages; p++) {
        const res = await getJobIndexApi(p, pag.size || 50);
        all.push(...(res.data.data.items ?? []));
    }

    return all;
};

export type JobLevelItem = {
  id: number;
  uuid: string;
  name: string;
  code: string;
  rank: number;
  description: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type JobLevelIndexResponse = {
  success: boolean;
  requestId: string;
  data: {
    success: boolean;
    data: {
      items: JobLevelItem[];
    };
  };
};

export const getJobLevelIndexApi = () =>
  ApiGet<JobLevelIndexResponse>(
    API_ENDPOINTS.GET_JOB_LEVEL_INDEX ?? "/api/job-level/index"
  );